import { render, staticRenderFns } from "./SocialStudies.vue?vue&type=template&id=3fa15c25&scoped=true&"
import script from "./SocialStudies.vue?vue&type=script&lang=js&"
export * from "./SocialStudies.vue?vue&type=script&lang=js&"
import style0 from "./SocialStudies.vue?vue&type=style&index=0&id=3fa15c25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa15c25",
  null
  
)

export default component.exports